(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    class IbProductGallery extends HTMLElement {
    connectedCallback() {
      this.thumbs = this.querySelectorAll('.ib-pdp-gallery__thumb');
      this.images = this.querySelectorAll('.ib-pdp-gallery__image');

      this.main = this.querySelector('.ib-pdp-gallery__main');
      this.indicators = this.querySelectorAll('.ib-pdp-gallery__indicator-segment');
      this.prevBtn = this.querySelector('.ib-pdp-gallery__arrow--prev');
      this.nextBtn = this.querySelector('.ib-pdp-gallery__arrow--next');
      this.counterCurrent = this.querySelector('.ib-pdp-gallery__counter-current');
      this.isMobile = () => window.matchMedia('(max-width: 749px)').matches;
      this.activeIndex = 0;

      if (this.images.length > 0) {
        this.images[0].classList.add('is-active');
      }

      const setActiveDesktop = (index) => {
        const total = this.images.length;
        if (total === 0) return;
        if (index < 0) index = 0;
        if (index >= total) index = total - 1;
        this.activeIndex = index;
        this.images.forEach((img, i) => img.classList.toggle('is-active', i === index));
        this.thumbs.forEach((t, i) => {
          if (i === index) {
            t.setAttribute('aria-current', 'true');
          } else {
            t.removeAttribute('aria-current');
          }
        });
        if (this.counterCurrent) this.counterCurrent.textContent = String(index + 1);
        if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', index === 0);
        if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', index === total - 1);
      };

      this.thumbs.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          if (this.isMobile()) {
            const target = this.querySelector('#' + btn.dataset.target);
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            setActiveDesktop(i);
          }
        });
      });

      const slideTo = (delta) => {
        if (this.isMobile()) {
          if (!this.main) return;
          const slideWidth = this.main.offsetWidth;
          this.main.scrollBy({ left: slideWidth * delta, behavior: 'smooth' });
        } else {
          setActiveDesktop(this.activeIndex + delta);
        }
      };
      this.prevBtn?.addEventListener('click', () => slideTo(-1));
      this.nextBtn?.addEventListener('click', () => slideTo(1));

      const updateMobileIndicator = () => {
        if (!this.isMobile() || !this.main) return;
        const slideWidth = this.main.offsetWidth || 1;
        const index = Math.round(this.main.scrollLeft / slideWidth);
        this.indicators.forEach((seg, i) => seg.classList.toggle('is-active', i === index));
        if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', index === 0);
        if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', index >= this.indicators.length - 1);
      };
      this.main?.addEventListener('scroll', () => {
        cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(updateMobileIndicator);
      });
      updateMobileIndicator();

      this.images.forEach((el) => {
        const img = el.querySelector('img');
        if (!img) return;
        el.addEventListener('mousemove', (e) => {
          const rect = el.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
        });
        el.addEventListener('mouseleave', () => {
          img.style.transformOrigin = 'center';
        });
      });

      setActiveDesktop(0);
    }
  }

  if (!customElements.get('ib-product-gallery')) {
    customElements.define('ib-product-gallery', IbProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
